import React, { useState, useEffect, useRef } from 'react';
import { generateReciboPDF } from '../../utils/generateReciboPDF';
import { generateEstadoCuentaPDF } from '../../utils/generateEstadoCuentaPDF';
import { getConceptoCobro } from '../../api/conceptosCobro';
import { getStudentFinancialStatus } from '../../api/students';
import { useAuth } from '../../api/AuthContext';
import { cambiarEstadoPagoPorFolio } from '../../api/pagos';
import { getStudentDetailComplete } from '../../api/students';
import styles from '../../styles/GeneracionCargosManualesStyles/GeneracionCargosManuales.module.css';

// Utilidad para descargar PDF real
async function descargarReciboPDF(grupo, student) {
    // Log para depuración de los cargos originales
    console.log('Cargos originales:', grupo.pagos);
    try {
        // Obtener detalle completo del estudiante para asegurar dirección
        let studentFull = student;
        let idToUse = student?.id_estudiante || student?.id;
        if (idToUse) {
            try {
                studentFull = await getStudentDetailComplete(idToUse);
            } catch (e) {
                // Si falla, usar el objeto recibido
                studentFull = student;
            }
        }
        // Log para depuración
        console.log('[ReciboPDF] studentFull usado para PDF:', studentFull);
        const formaPago = String(grupo.formaPago || grupo.pagos[0]?.forma_pago || '').toUpperCase();
        const esPagoEnLinea = formaPago === 'PAGO_EN_LINEA';
        const usuarioCreacionId = grupo.pagos[0]?.usuario_creacion || null;
        const cajeroNombre = esPagoEnLinea
          ? ''
          : (
              grupo.pagos[0]?.usuario_creacion_nombre
              || grupo.pagos[0]?.usuario_creacion_usuario
              || ''
            );

        // Obtener todos los id_concepto únicos de los cargos
        const conceptoIdSet = new Set();
        grupo.pagos.forEach(c => {
            const idConcepto = c.id_concepto || c.concepto;
            if (idConcepto) conceptoIdSet.add(idConcepto);
        });
        const conceptoIdArr = Array.from(conceptoIdSet);

        // Mapa para cachear los codigos de concepto
        const conceptoCodigoMap = {};
        await Promise.all(conceptoIdArr.map(async (id) => {
            try {
                console.log('[CODIGO_CONCEPTO] Consultando id:', id);
                const concepto = await getConceptoCobro(id);
                console.log('[CODIGO_CONCEPTO] Resultado para id', id, ':', concepto);
                conceptoCodigoMap[id] = concepto.codigo_concepto || '';
            } catch (e) {
                console.error('[CODIGO_CONCEPTO] Error consultando id', id, e);
                conceptoCodigoMap[id] = '';
            }
        }));

        // Agrupar los cargos del grupo, agregando codigo_concepto
        const cargosPDF = grupo.pagos.map(c => {
            const idConcepto = c.id_concepto || c.concepto;
            return {
                ...c,
                monto: typeof c.monto_aplicado === 'number'
                    ? c.monto_aplicado
                    : parseFloat(c.monto_aplicado || c.monto || c.monto_neto || c.monto_original) || 0,
                monto_recargo: typeof c.monto_recargo === 'number'
                    ? c.monto_recargo
                    : parseFloat(c.monto_recargo || c.recargo || 0) || 0,
                cantidad: c.cantidad || 1,
                descripcion_concepto: c.descripcion_concepto || c.descripcion || '',
                motivo: c.motivo || '',
                id_concepto: idConcepto || '',
                codigo_concepto: c.codigo_concepto || conceptoCodigoMap[idConcepto] || '',
                id_cargo: c.id_cargo || c.id || null
            };
        });

        // Adaptar campos para el PDF
          const studentPDF = {
            ...studentFull,
            nombre: studentFull.nombre || studentFull.nombre_completo || '',
            seccion: studentFull.seccion || studentFull.seccion_nombre || '',
            curp: studentFull.curp || '',
          };

        // Normalizar fechaElaboracion a YYYY-MM-DD para evitar errores de interpretación
        let fechaElaboracion = grupo.pagos[0]?.fecha || null;
        if (fechaElaboracion && typeof fechaElaboracion === 'string') {
          // Si viene como YYYY-MM-DDTHH:mm:ss, tomar solo la parte de la fecha
          const match = fechaElaboracion.match(/^(\d{4}-\d{2}-\d{2})/);
          if (match) {
            fechaElaboracion = match[1];
          }
        }
        const dataUri = await generateReciboPDF({
          student: studentPDF,
          charges: cargosPDF,
          paymentData: {
            forma_pago: grupo.formaPago,
            referencia: grupo.pagos[0]?.referencia || grupo.pagos[0]?.referencia_bancaria || '',
            observaciones: grupo.pagos[0]?.observaciones || '',
            codigo_recibo: grupo.folio,
            cajero: cajeroNombre,
            usuario_creacion: esPagoEnLinea ? null : usuarioCreacionId
          },
          isEmail: false,
          fechaElaboracion,
          lugar: studentFull.campus ? studentFull.campus : null
        });
        if (dataUri && typeof window !== 'undefined') {
            try {
                const base64ForDownload = dataUri.includes(',') ? dataUri.split(',')[1] : dataUri;
                const byteCharacters = atob(base64ForDownload);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                const fechaPagoSafe = (grupo.pagos[0]?.fecha_pago || '').replace(/[^0-9]/g, '');
                const folioSafe = (grupo.folio || 'recibo').toString().replace(/[^A-Za-z0-9_-]/g, '');
                link.href = url;
                link.download = `recibo_${fechaPagoSafe}_${folioSafe}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (downloadError) {
                alert('Error al descargar el PDF');
                console.error('Error al forzar la descarga del recibo PDF:', downloadError);
            }
        } else {
            alert('No se pudo generar el PDF.');
        }
    } catch (err) {
        alert('Error al generar el PDF.');
        console.error('Error al generar el PDF de recibo:', err);
    }
}

/**
 * Componente HistorialPagosSection
 * Muestra el historial de pagos del estudiante.
 * Reutiliza la lógica existente de EstadoFinanciero.jsx de EstudiantesScreen
 */
function HistorialPagosSection({ studentId, refreshKey = 0, student = null }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [estadoCuenta, setEstadoCuenta] = useState(null);
  const [collapsed, setCollapsed] = useState(true);
  const [expandedFolios, setExpandedFolios] = useState({});
  const [expandedCiclos, setExpandedCiclos] = useState({});
  const [printingPDF, setPrintingPDF] = useState(false);

  const userRole = user?.rol_nombre || user?.rol || '';
  const isSuperAdmin = !!userRole && userRole.toLowerCase().includes('superadmin');

  // Cargar estado financiero cuando cambie el estudiante o refreshKey
  useEffect(() => {
    const fetchEstadoCuenta = async () => {
      if (!studentId) {
        setEstadoCuenta(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await getStudentFinancialStatus(studentId);
        // La API retorna directamente el objeto con los datos (sin wrapper success/data)
        if (response && (response.historial_pagos || response.resumen)) {
          setEstadoCuenta(response);
        } else if (response.error) {
          setError(response.error || 'Error al obtener el estado de cuenta');
        } else {
          setError('Respuesta inválida del servidor');
        }
      } catch (err) {
        console.error('Error fetching estado cuenta:', err);
        // Si es error 404, significa que el estudiante no tiene datos financieros
        if (err.response?.status === 404) {
          setEstadoCuenta({ historial_pagos: [], resumen: null });
        } else {
          setError('Error al cargar el historial de pagos');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEstadoCuenta();
  }, [studentId, refreshKey]);

  const historialPagos = estadoCuenta?.historial_pagos || [];
  const adeudosPendientes = estadoCuenta?.cargos_pendientes || [];
  const resumen = estadoCuenta?.resumen || {};

  const [conceptoCodigoMap, setConceptoCodigoMap] = useState({});

  // Cargar los codigos_concepto para los pagos
  useEffect(() => {
    async function fetchCodigosConcepto() {
      if (!estadoCuenta || !estadoCuenta.historial_pagos || estadoCuenta.historial_pagos.length === 0) {
        setConceptoCodigoMap({});
        return;
      }
      console.log('[CODIGO_CONCEPTO] historial_pagos:', estadoCuenta.historial_pagos);
      const ids = Array.from(new Set(estadoCuenta.historial_pagos.map(p => p.id_concepto || p.concepto).filter(Boolean)));
      console.log('[CODIGO_CONCEPTO] ids a consultar:', ids);
      const map = {};
      await Promise.all(ids.map(async (id) => {
        try {
          console.log('[CODIGO_CONCEPTO] Consultando id:', id);
          const concepto = await getConceptoCobro(id);
          console.log('[CODIGO_CONCEPTO] Resultado para id', id, ':', concepto);
          map[id] = concepto.codigo_concepto || '';
        } catch (e) {
          console.error('[CODIGO_CONCEPTO] Error consultando id', id, e);
          map[id] = '';
        }
      }));
      setConceptoCodigoMap(map);
      console.log('[CODIGO_CONCEPTO] Mapa final:', map);
    }
    fetchCodigosConcepto();
  }, [estadoCuenta]);

  // Helpers para formateo (reutilizados de EstadoFinanciero.jsx)
  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    return num.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2
    });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    // Si viene en formato dd/mm/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('/');
      return `${day}/${month}/${year}`;
    }
    // Si viene en formato ISO o compatible
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      return date.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return dateStr;
    }
  };

  // Agrupar pagos: primero por ciclo, luego por folio dentro de cada ciclo
  const pagosPorCiclo = React.useMemo(() => {
    const ciclosMap = new Map();

    historialPagos.forEach((pago) => {
      const cicloKey = pago.id_ciclo_escolar ?? 'sin_ciclo';
      const cicloNombre = pago.ciclo_nombre || (pago.id_ciclo_escolar ? `Ciclo ${pago.id_ciclo_escolar}` : 'Sin Ciclo');

      if (!ciclosMap.has(cicloKey)) {
        ciclosMap.set(cicloKey, {
          id_ciclo_escolar: cicloKey,
          ciclo_nombre: cicloNombre,
          totalMonto: 0,
          foliosMap: new Map(),
        });
      }

      const ciclo = ciclosMap.get(cicloKey);
      const folio = pago.folio_recibo || pago.folio || 'SIN FOLIO';
      // Calcular descuento de beca: monto_original - monto_aplicado
      const montoOriginal = parseFloat(pago.monto_original || 0) || 0;
      const montoAplicado = parseFloat(pago.monto_aplicado || pago.monto || 0) || 0;
      const descuentoBeca = montoOriginal > montoAplicado ? (montoOriginal - montoAplicado) : 0;
      const montoRecargo = parseFloat(pago.monto_recargo || 0) || 0;
      const montoFila = montoAplicado + montoRecargo;

      if (!ciclo.foliosMap.has(folio)) {
        ciclo.foliosMap.set(folio, {
          folio,
          pagos: [],
          totalMonto: 0,
          totalDescuentoBeca: 0,
          totalRecargo: 0,
          fecha: pago.fecha,
          formaPago: pago.forma_pago || '-',
          estado: pago.estado_pago || pago.estado || 'APLICADO',
        });
      }

      const grupo = ciclo.foliosMap.get(folio);
      grupo.totalMonto += isNaN(montoFila) ? 0 : montoFila;
      grupo.totalDescuentoBeca += isNaN(descuentoBeca) ? 0 : descuentoBeca;
      grupo.totalRecargo += isNaN(montoRecargo) ? 0 : montoRecargo;
      // Enriquecer pago con descuento calculado
      pago.descuento_beca_calculado = descuentoBeca;
      grupo.pagos.push(pago);
      ciclo.totalMonto += isNaN(montoFila) ? 0 : montoFila;
    });

    // Parsea "2026-2", "2026-03", etc. → { anio: 2026, periodo: 2 }
    const parseCiclo = (nombre) => {
      const match = String(nombre || '').match(/^(\d{4})[^0-9](\d+)$/);
      if (!match) return { anio: 0, periodo: 0 };
      return { anio: parseInt(match[1]), periodo: parseInt(match[2]) };
    };

    return Array.from(ciclosMap.values())
      .map((ciclo) => ({
        ...ciclo,
        gruposFolio: Array.from(ciclo.foliosMap.values()),
      }))
      .sort((a, b) => {
        if (a.id_ciclo_escolar === 'sin_ciclo') return 1;
        if (b.id_ciclo_escolar === 'sin_ciclo') return -1;
        const ca = parseCiclo(a.ciclo_nombre);
        const cb = parseCiclo(b.ciclo_nombre);
        if (cb.anio !== ca.anio) return cb.anio - ca.anio;
        return cb.periodo - ca.periodo;
      });
  }, [historialPagos]);

  // Mantener pagosPorFolio como lista plana para el badge de conteo
  const pagosPorFolio = React.useMemo(() => pagosPorCiclo.flatMap((c) => c.gruposFolio), [pagosPorCiclo]);

  const toggleFolioExpand = (folio) => {
    setExpandedFolios((prev) => ({
      ...prev,
      [folio]: !prev[folio]
    }));
  };

  const toggleCicloExpand = (cicloKey) => {
    setExpandedCiclos((prev) => ({
      ...prev,
      [cicloKey]: !prev[cicloKey]
    }));
  };

  const handlePrintEstadoCuenta = async () => {
    if (!estadoCuenta) {
      alert('No hay datos de estado de cuenta para imprimir.');
      return;
    }
    setPrintingPDF(true);
    try {
      const studentData = { ...(student || {}), ...(estadoCuenta?.estudiante || {}) };
      await generateEstadoCuentaPDF({
        student: studentData,
        pagosPorCiclo,
        adeudosPendientes,
        resumen,
        descargar: true,
        folio: studentData.folio || studentData.folio_recibo || student?.folio || student?.folio_recibo || ''
      });
    } catch (err) {
      console.error('Error al generar el Estado de Cuenta PDF:', err);
      alert('Error al generar el PDF. Por favor intente de nuevo.');
    } finally {
      setPrintingPDF(false);
    }
  };

  const recargarHistorial = async () => {
    if (!studentId) return;
    try {
      const response = await getStudentFinancialStatus(studentId);
      if (response && (response.historial_pagos || response.resumen)) {
        setEstadoCuenta(response);
      }
    } catch (err) {
      console.error('Error recargando historial de pagos:', err);
    }
  };

  const handleCancelarRecibo = async (grupo) => {
    const folio = grupo.folio || 'SIN FOLIO';
    const montoTotal = formatCurrency(grupo.totalMonto || 0);
    const confirmado = window.confirm(`¿Está seguro de cancelar el recibo ${folio} por ${montoTotal}?`);
    if (!confirmado) return;
    console.log('[HistorialPagos] Solicitud de cancelación de recibo:', folio, grupo);

    if (!grupo.folio || grupo.folio === 'SIN FOLIO') {
      alert('No se puede cancelar un recibo sin folio.');
      return;
    }

    try {
      setLoading(true);
      const result = await cambiarEstadoPagoPorFolio(grupo.folio, 'CANCELADO');
      if (!result || result.success === false) {
        const msg = (result && (result.error || result.message)) || 'No se pudo cancelar el recibo.';
        alert(`❌ ${msg}`);
      } else {
        await recargarHistorial();
        alert('✅ El recibo se canceló correctamente.');
      }
    } catch (err) {
      console.error('Error al cancelar el recibo:', err);
      const msg = err && (err.error || err.message) ? (err.error || err.message) : 'No se pudo cancelar el recibo.';
      alert(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDescancelarRecibo = async (grupo) => {
    const folio = grupo.folio || 'SIN FOLIO';
    const montoTotal = formatCurrency(grupo.totalMonto || 0);
    const confirmado = window.confirm(`¿Está seguro de volver a aplicar el recibo ${folio} por ${montoTotal}?`);
    if (!confirmado) return;

    if (!grupo.folio || grupo.folio === 'SIN FOLIO') {
      alert('No se puede descancelar un recibo sin folio.');
      return;
    }

    try {
      setLoading(true);
      const result = await cambiarEstadoPagoPorFolio(grupo.folio, 'APLICADO');
      if (!result || result.success === false) {
        const msg = (result && (result.error || result.message)) || 'No se pudo volver a aplicar el recibo.';
        alert(`❌ ${msg}`);
      } else {
        await recargarHistorial();
        alert('✅ El recibo se volvió a aplicar correctamente.');
      }
    } catch (err) {
      console.error('Error al descancelar el recibo:', err);
      const msg = err && (err.error || err.message) ? (err.error || err.message) : 'No se pudo volver a aplicar el recibo.';
      alert(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  // Estado para menú de acciones
  const [menuAccion, setMenuAccion] = useState({ open: false, anchor: null, grupo: null });
  const menuRef = useRef();

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    if (!menuAccion.open) return;
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuAccion({ open: false, anchor: null, grupo: null });
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuAccion.open]);
  if (loading) {
    return (
      <div className={styles.historialPagosCard}>
        <div className={styles.historialPagosHeader}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#00857C"/>
          </svg>
          <h3>Historial de Pagos</h3>
        </div>
        <div className={styles.historialPagosBody}>
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            <span className={styles.spinner}></span>
            Cargando historial de pagos...
          </div>
        </div>
      </div>
    );
  }

  // Estado de error
  if (error) {
    return (
      <div className={styles.historialPagosCard}>
        <div className={styles.historialPagosHeader}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#00857C"/>
          </svg>
          <h3>Historial de Pagos</h3>
        </div>
        <div className={styles.historialPagosBody}>
          <div style={{ textAlign: 'center', padding: '20px', color: '#dc3545' }}>
            {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.historialPagosCard}>
      {/* Header con toggle para colapsar */}
      <div 
        className={styles.historialPagosHeader}
        onClick={() => setCollapsed(!collapsed)}
        style={{ cursor: 'pointer' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#00857C"/>
          </svg>
          <h3>Historial de Pagos</h3>
          {historialPagos.length > 0 && (
            <span className={styles.historialBadge}>
              {historialPagos.length} pago{historialPagos.length !== 1 ? 's' : ''}
            </span>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} onClick={e => e.stopPropagation()}>
          <button
            onClick={handlePrintEstadoCuenta}
            disabled={printingPDF || !estadoCuenta}
            title="Imprimir Estado de Cuenta"
            style={{
              display: 'flex', alignItems: 'center', gap: '5px',
              padding: '5px 10px', fontSize: '12px', fontWeight: '500',
              background: '#00857C', color: '#fff', border: 'none',
              borderRadius: '4px',
              cursor: printingPDF || !estadoCuenta ? 'not-allowed' : 'pointer',
              opacity: printingPDF || !estadoCuenta ? 0.6 : 1,
              whiteSpace: 'nowrap',
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M19 8H5C3.34 8 2 9.34 2 11v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" fill="currentColor"/>
            </svg>
            {printingPDF ? 'Generando...' : 'Estado de Cuenta'}
          </button>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            style={{
              transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease'
            }}
          >
            <path d="M6 9L12 15L18 9" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>

      {/* Contenido colapsable */}
      {!collapsed && (
        <div className={styles.historialPagosBody}>
          {/* Resumen financiero */}
          {resumen && (
            <div className={styles.resumenFinanciero}>
              <div className={styles.resumenItem}>
                <span className={styles.resumenLabel}>Saldo Total:</span>
                <span className={styles.resumenValue}>{formatCurrency(resumen.saldo_total)}</span>
              </div>
              <div className={styles.resumenItem}>
                <span className={styles.resumenLabel}>Saldo Vencido:</span>
                <span className={parseFloat(resumen.saldo_vencido) > 0 ? styles.resumenValueNegative : styles.resumenValuePositive}>
                  {formatCurrency(resumen.saldo_vencido)}
                </span>
              </div>
              <div className={styles.resumenItem}>
                <span className={styles.resumenLabel}>Próximo Vencimiento:</span>
                <span className={styles.resumenValue}>
                  {formatCurrency(resumen.proximo_vencimiento)} ({resumen.proxima_fecha_vencimiento || 'N/A'})
                </span>
              </div>
            </div>
          )}

          {/* Tabla de historial */}
          {historialPagos.length > 0 ? (
            <div className={styles.tableContainer}>
              <table className={styles.historialTable}>
                <thead>
                  <tr>
                    <th></th>
                    <th>Ciclo</th>
                    <th>Fecha</th>
                    <th>Concepto</th>
                    <th>Descripción</th>
                    <th>Monto Original</th>
                    <th>Desc. Beca</th>
                    <th>Recargo</th>
                    <th>Total</th>
                    <th>Estado</th>
                    {isSuperAdmin && <th>Acciones</th>}
                  </tr>
                </thead>
                <tbody>
                  {pagosPorCiclo.map((ciclo) => {
                    const cicloExpanded = !!expandedCiclos[ciclo.id_ciclo_escolar];
                    const colCount = isSuperAdmin ? 11 : 10;
                    return (
                      <React.Fragment key={ciclo.id_ciclo_escolar}>
                        {/* Fila de agrupación por ciclo */}
                        <tr
                          className={styles.historialCicloRow}
                          onClick={() => toggleCicloExpand(ciclo.id_ciclo_escolar)}
                          style={{ cursor: 'pointer' }}
                        >
                          <td colSpan={colCount}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <svg
                                width="14" height="14" viewBox="0 0 24 24"
                                style={{ transition: 'transform 0.2s', transform: cicloExpanded ? 'rotate(0deg)' : 'rotate(-90deg)', flexShrink: 0, color: 'white' }}
                              >
                                <path d="M8 10L12 14L16 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              <span style={{ fontWeight: 600, color: 'white' }}>{ciclo.ciclo_nombre}</span>
                              <span className={styles.historialBadge} style={{ marginLeft: 4 }}>
                                {ciclo.gruposFolio.length} recibo{ciclo.gruposFolio.length !== 1 ? 's' : ''}
                              </span>
                              <span style={{ marginLeft: 'auto', fontWeight: 600, color: 'white' }}>
                                {formatCurrency(ciclo.totalMonto)}
                              </span>
                            </div>
                          </td>
                        </tr>

                        {/* Filas de folios dentro del ciclo */}
                        {cicloExpanded && ciclo.gruposFolio.map((grupo, indexGrupo) => {
                          const primerPago = grupo.pagos[0] || {};
                          const conceptosUnicos = Array.from(
                            new Set(grupo.pagos.map((p) => p.concepto || p.descripcion || '-'))
                          );
                          const conceptosExtra = Math.max(conceptosUnicos.length - 1, 0);
                          const conceptoPrincipal = conceptosUnicos[0] || '-';

                          const estadoGrupo = primerPago.estado_pago || primerPago.estado || 'APLICADO';
                          const esCancelado = estadoGrupo === 'CANCELADO';
                          const esMultiple = grupo.pagos.length > 1;
                          const expandido = esMultiple && !!expandedFolios[grupo.folio];

                          return (
                            <React.Fragment key={grupo.folio || indexGrupo}>
                              <tr className={styles.historialGroupRow}>
                                <td
                                  className={styles.expandCell}
                                  onClick={esMultiple ? () => toggleFolioExpand(grupo.folio) : undefined}
                                >
                                  {esMultiple && (
                                    <svg
                                      width="14" height="14" viewBox="0 0 24 24"
                                      className={styles.expandIcon}
                                      style={{ transform: expandido ? 'rotate(0deg)' : 'rotate(-90deg)' }}
                                    >
                                      <path d="M8 10L12 14L16 10" stroke="#4a5568" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                  )}
                                </td>
                                <td>{ciclo.ciclo_nombre || '-'}</td>
                                <td>{formatDate(grupo.fecha)}</td>
                                <td>
                                  {expandido ? (
                                    <span className={styles.groupExpandedLabel}>CARGOS DE ESTE RECIBO</span>
                                  ) : (
                                    <>
                                      {conceptoPrincipal}
                                      {conceptosExtra > 0 && (
                                        <span className={styles.multipleConceptSuffix}>
                                          {` (+ ${conceptosExtra} cargo${conceptosExtra > 1 ? 's' : ''} más)`}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </td>
                                <td style={{ fontSize: '12px' }}>
                                  {grupo.pagos[0]?.descripcion_concepto || '-'}
                                </td>
                                <td className={esCancelado ? styles.montoCancelado : styles.montoPositivo}>
                                  {formatCurrency(grupo.pagos[0]?.monto_original || 0)}
                                </td>
                                <td className={esCancelado ? styles.montoCancelado : styles.montoPositivo} style={{ color: grupo.totalDescuentoBeca > 0 ? '#10b981' : 'inherit' }}>
                                  {grupo.totalDescuentoBeca > 0 ? `-${formatCurrency(grupo.totalDescuentoBeca)}` : '-'}
                                </td>
                                <td className={esCancelado ? styles.montoCancelado : styles.montoPositivo}>
                                  {formatCurrency(grupo.totalRecargo || 0)}
                                </td>
                                <td className={esCancelado ? styles.montoCancelado : styles.montoPositivo}>
                                  {formatCurrency(grupo.totalMonto)}
                                </td>
                                <td>
                                  <span
                                    className={
                                      estadoGrupo === 'CANCELADO'
                                        ? styles.estadoBadgeCancelado
                                        : estadoGrupo === 'APLICADO' || estadoGrupo === 'SALDADO'
                                          ? styles.estadoBadgeSaldado
                                          : estadoGrupo === 'PENDIENTE'
                                            ? styles.estadoBadgePendiente
                                            : styles.estadoBadgeDefault
                                    }
                                  >
                                    {estadoGrupo}
                                  </span>
                                </td>
                                {isSuperAdmin && (
                                  <td style={{ position: 'relative' }}>
                                    <button
                                      type="button"
                                      className={styles.historialActionMenuButton || ''}
                                      aria-label="Acciones"
                                      onClick={e => {
                                        setMenuAccion({ open: true, anchor: e.currentTarget, grupo });
                                      }}
                                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}
                                    >
                                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="5" r="2" fill="#666" />
                                        <circle cx="12" cy="12" r="2" fill="#666" />
                                        <circle cx="12" cy="19" r="2" fill="#666" />
                                      </svg>
                                    </button>
                                    {menuAccion.open && menuAccion.grupo === grupo && (
                                      <div
                                        ref={menuRef}
                                        style={{
                                          position: 'absolute',
                                          top: 30,
                                          right: 0,
                                          background: '#fff',
                                          border: '1px solid #e0e0e0',
                                          borderRadius: 6,
                                          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                                          zIndex: 10,
                                          minWidth: 160,
                                        }}
                                      >
                                        {(estadoGrupo === 'APLICADO') && (
                                          <div
                                            style={{ padding: '10px 18px', cursor: 'pointer', color: '#c0392b', fontWeight: 500 }}
                                            onClick={() => {
                                              setMenuAccion({ open: false, anchor: null, grupo: null });
                                              handleCancelarRecibo(grupo);
                                            }}
                                          >
                                            Cancelar
                                          </div>
                                        )}
                                        {(estadoGrupo === 'CANCELADO') && (
                                          <div
                                            style={{ padding: '10px 18px', cursor: 'pointer', color: '#00857C', fontWeight: 500 }}
                                            onClick={() => {
                                              setMenuAccion({ open: false, anchor: null, grupo: null });
                                              handleDescancelarRecibo(grupo);
                                            }}
                                          >
                                            Aplicar
                                          </div>
                                        )}
                                        <div
                                          style={{ padding: '10px 18px', cursor: 'pointer', color: '#002f6c', fontWeight: 500, borderTop: '1px solid #f0f0f0' }}
                                          onClick={async () => {
                                            setMenuAccion({ open: false, anchor: null, grupo: null });
                                            await descargarReciboPDF(grupo, estadoCuenta?.estudiante || {});
                                          }}
                                        >
                                          Descargar PDF
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                )}
                              </tr>
                              {esMultiple && expandido &&
                                grupo.pagos.map((pago, indexPago) => {
                                  const estado = pago.estado_pago || pago.estado || 'APLICADO';
                                  const esCanceladoDetalle = estado === 'CANCELADO';
                                  const montoDetalle =
                                    (parseFloat(pago.monto_aplicado || pago.monto || 0) || 0) +
                                    (parseFloat(pago.monto_recargo || 0) || 0);

                                  return (
                                    <tr
                                      key={`${grupo.folio || indexGrupo}-${indexPago}`}
                                      className={styles.historialDetailRow}
                                    >
                                      <td></td>
                                      <td>{pago.ciclo_nombre || '-'}</td>
                                      <td>{formatDate(pago.fecha)}</td>
                                      <td className={styles.historialDetailConcept}>
                                        {pago.concepto || '-'}
                                      </td>
                                      <td style={{ fontSize: '12px' }}>
                                        {pago.descripcion_concepto || '-'}
                                      </td>
                                      <td>
                                        {esCanceladoDetalle ? (
                                          <span className={styles.montoCancelado}>{formatCurrency(pago.monto_original || 0)}</span>
                                        ) : (
                                          <span className={styles.montoDetalle}>{formatCurrency(pago.monto_original || 0)}</span>
                                        )}
                                      </td>
                                      <td style={{ color: pago.descuento_beca_calculado > 0 ? '#10b981' : 'inherit' }}>
                                        {pago.descuento_beca_calculado > 0 ? `-${formatCurrency(pago.descuento_beca_calculado)}` : '-'}
                                      </td>
                                      <td>
                                        {esCanceladoDetalle ? (
                                          <span className={styles.montoCancelado}>{formatCurrency(pago.monto_recargo || 0)}</span>
                                        ) : (
                                          <span className={styles.montoDetalle}>{formatCurrency(pago.monto_recargo || 0)}</span>
                                        )}
                                      </td>
                                      <td>
                                        {esCanceladoDetalle ? (
                                          <span className={styles.montoCancelado}>{formatCurrency(montoDetalle)}</span>
                                        ) : (
                                          <span className={styles.montoDetalle}>{formatCurrency(montoDetalle)}</span>
                                        )}
                                      </td>
                                      <td colSpan={isSuperAdmin ? 2 : 1}></td>
                                    </tr>
                                  );
                                })}
                            </React.Fragment>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className={styles.emptyHistorial}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3ZM19 19H5V8H19V19ZM7 10H17V12H7V10ZM7 14H14V16H7V14Z" fill="#ccc"/>
              </svg>
              <p>No hay pagos registrados para este estudiante</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default HistorialPagosSection;
